import React, { Component } from 'react';
import getSize from "../../utils/getSize";
import NHFetch from "../../utils/NHFetch";
import NHTable from '../common/NHTable';
import { NHModal, NHConfirm } from '../common/NHModal';
import NHExcel from '../common/NHNewExcel/index'; 
import { hasAuth,createUuid } from '../../utils/NHCore';
import { Button,Select,Input, Row, Col, message, Radio } from 'antd';
const RadioGroup = Radio.Group;
import css from './index.css';
const { Option } = Select;

export default class Zyzxx extends Component {
    constructor(props) {
        super(props)
        this.state = {
            initParams: {},
            columns:[],
            titleModal:"",//弹窗标题
            modalList:["志愿者联系电话","志愿者微信","学生姓名","学生身份证号"],//弹窗input数据渲染
            sexual:["男", "女"],
            zyzxm:"",//志愿者姓名
            zyzxb:"",//志愿者性别
            zyzdh:"",//志愿者联系电话
            zyzbj:"",//志愿者班级
            zyzwx:"",//志愿者微信
            xsxm:"",//学生姓名
            xssfzh:""//学生身份证号
        }
    }
    componentWillMount() {
        const columnConst = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '100px',
            }, {
                title: '志愿者姓名',
                dataIndex: 'ZYZXM',
                search: 'input',
                width: '100px',
                searchType:"input"
            }, {
                title: '志愿者性别',
                dataIndex: 'ZYZXB',
                search: 'input',
                width: '50px',
                searchType:"select"
            }, {
                title: '志愿者联系电话',
                dataIndex: 'ZYZDH',
                search: 'input',
                width: '100px',
                searchType:"input"
            }, {
                title: '志愿者微信',
                dataIndex: 'ZYZWX',
                search: 'input',
                width: '130px',
                searchType:"input"
            }, {
                title: '学生姓名',
                dataIndex: 'XSXM',
                search: 'input',
                width: '100px',
                searchType:"input"
            }, {
                title: '学生身份证号',
                dataIndex: 'XSSFZH',
                search: 'input',
                width: '120px',
                searchType:"input"
            }
        ];
        this.setState({
            columns:columnConst,
        });
    }

    // 导出excel
    handleExportBtnClick = () => {
        this.refs.nhTable.exportExcel('导出志愿者信息');
    };

    // 行内删除
    handleDeleteBtnClick = (record) =>{
        NHConfirm("是否确定删除选中的志愿者信息？", () => {
            let pkid = record.PKID;
        NHFetch('/volunteer/delVolunteer', 'GET', {pkid}).then(res => {
                if (res && res.data) {
                    if(res.code == "200"){
                        message.success("志愿者信息删除成功！")
                        this.refs.nhTable.filterTableData();
                    }
                } else {
                    message.error('志愿者信息删除失败！')
                }
            })
        }, "warn");
    }

    // 行内--修改
    handleEditBtnClick = (record) =>{
        this.setState({
            titleModal:"修改志愿者信息",
            pkid: record.PKID,
            zyzxm: record.ZYZXM,
            zyzxb: record.ZYZXB,
            zyzdh: record.ZYZDH,
            zyzbj: record.ZYZBJ,
            zyzwx: record.ZYZWX,
            xsxm:record.XSXM,
            xssfzh:record.XSSFZH
        },() =>{
            this.refs.editModal.show();
            console.log("修改");
        })
    }

    // 新增
    handleAddBtnClick = () =>{
        this.setState({
            titleModal:"新增志愿者信息",
        },() =>{
            this.refs.editModal.show();
        })
    }

    // 导入
    handleImportBtnClick = () =>{
        this.refs.nhExcelBase.show();
        console.log("导入");
    }
    // 关闭导入弹窗
    onExcelClose = () => {
        this.refs.nhTable.filterTableData();
    };

    // 弹窗-- 确认
    handleSumbitBtnClick = () =>{
        const {zyzxm,zyzxb,zyzdh,zyzbj,zyzwx,xsxm,xssfzh} = this.state;
        if(zyzxm == "" && zyzxb == ""){
            message.warning("请先完善填写好数据！");
            this.refs.editModal.stopLoading();
            return ;
        }
        if(zyzxm && zyzxm == ""){
            message.warning("志愿者姓名不能为空！");
            this.refs.editModal.stopLoading();
            return ;
        }
        if(zyzxb && zyzxb == ""){
            message.warning("志愿者性别不能为空！");
            this.refs.editModal.stopLoading();
            return ;
        }
        if(zyzdh && zyzdh != ""){
            let data = /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/;
            if(!data.test(zyzdh)){
                message.warning("请输入正确的联系电话！");
                this.refs.editModal.stopLoading();
                return ;
            }
        }
        if(xssfzh && xssfzh != ""){
            let data = /^[1-9]\d{5}(\d{4})((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
            if(!data.test(xssfzh)){
                message.warning("请输入正确的身份证号！");
                this.refs.editModal.stopLoading();
                return ;
            }
        }
        
        console.log("确认",zyzxm,zyzxb,zyzdh,zyzbj,zyzwx,xsxm,xssfzh);
        const {titleModal, pkid} = this.state;
        let param = {
            pkid: titleModal == '新增志愿者信息' ? createUuid() : pkid,
            xm: zyzxm,
            xb: zyzxb,
            lxdh: zyzdh,
            wx: zyzwx,
            fwdxxm: xsxm,
            fwdxsfzjh: xssfzh,
        };
        NHFetch('/volunteer/saveOrUpdateVolunteer', 'POST', param).then(res => {
            if (res && res.data) {
                if(res.code == "200"){
                    this.refs.editModal.close();
                    message.success("志愿者信息保存成功！")
                    this.refs.nhTable.filterTableData();
                    this.setState({
                        zyzxm: '',
                        zyzxb: '',
                        zyzdh: '',
                        zyzwx: '',
                        xsxm: '',
                        xssfzh: '',
                    })
                }
            } else {
                message.error('志愿者信息保存失败！')
            }
        })

    }

    // 文本框输入
    hadelTextChange = (e,item) =>{
        e.persist()
        if(item == "志愿者姓名"){
            this.setState({
                zyzxm:e.target.value
            })
        }else if(item == "志愿者联系电话"){
            this.setState({
                zyzdh:e.target.value
            })
        }else if(item == "志愿者微信"){
            this.setState({
                zyzwx:e.target.value
            })
        }else if(item == "学生姓名"){
            this.setState({
                xsxm:e.target.value
            })
        }else if(item == "学生身份证号"){
            this.setState({
                xssfzh:e.target.value
            })
        }
    }

    onRadioChange = (e) => {
        this.setState({zyzxb: e.target.value});
    }

    render() {
        const {titleModal,zyzxm,zyzxb,zyzdh,zyzbj,zyzwx,xsxm,xssfzh} = this.state;
        let sqlParams= {};

        const actions = [
            { title: '修改', onClick: this.handleEditBtnClick,auth:'zhxg_yxgl_zyzxx:update'},
            { title: '删除', onClick: this.handleDeleteBtnClick,auth:'zhxg_yxgl_zyzxx:delete'},
        ];
        return(
            <div className={css.main_right_content} style={{height:getSize().windowH-123}}>
                <div className={{width: '100%', height: '100%',}} >
                    <NHTable
                        ref="nhTable"
                        rowKey={record => record.PKID}
                        columns={this.state.columns}
                        sign={"zhxg_yxxt_volunteerInfo"}
                        sqlParams={sqlParams}
                        action={actions}
                    >
                    {hasAuth('zhxg_yxgl_zyzxx:add')?<Button type="primary" onClick={() => this.handleAddBtnClick()} style={{marginRight:"15px"}}>新增</Button>:undefined}
                    {hasAuth('zhxg_yxgl_zyzxx:import')?<Button type="primary" ghost onClick={() => this.handleImportBtnClick()} style={{marginRight:"15px"}}>导入</Button>:undefined}
                    {hasAuth('zhxg_yxgl_zyzxx:export')?<Button type="primary" ghost onClick={() => this.handleExportBtnClick()} style={{marginRight:"15px"}}>导出</Button>:undefined}
                    </NHTable>
                </div>
                <NHModal ref="editModal"
                        title={this.state.titleModal}
                        width={600}
                        onOk={this.handleSumbitBtnClick}
                        destroyOnClose={true}
                    >
                        <div style={{margin:"0px auto",height:"220px"}}>
                            <div style={{marginTop:"10px"}}>
                                <Row type="flex" gutter={8} style={{marginLeft:"-8px!important"}}>
                                        <Col span={6}>
                                            <Col><span style={{ margin: "16px 0" }}><span style={{color:"#f4364c"}}>*</span>志愿者姓名:</span></Col>
                                        </Col>
                                        <Col span={10}  style={{marginLeft:"10px"}}>
                                            <Input placeholder='请输入志愿者姓名' onChange={(e) => this.hadelTextChange(e,"志愿者姓名")} value={this.state.zyzxm}/>
                                        </Col>
                                    </Row>
                            </div>

                            <div style={{marginTop:"10px"}}>
                                <Row type="flex" gutter={8} style={{marginLeft:"-8px!important"}}>
                                        <Col span={6}>
                                            <Col><span style={{ margin: "16px 0" }}><span style={{color:"#f4364c"}}>*</span>志愿者性别:</span></Col>
                                        </Col>
                                    <Col span={10}  style={{marginLeft:"10px"}}>
                                            <RadioGroup onChange={this.onRadioChange} value={zyzxb}>
                                                <Radio value={this.state.sexual[0]}>男</Radio>
                                                <Radio value={this.state.sexual[1]}>女</Radio>
                                            </RadioGroup>
                                        </Col>
                                    </Row>
                            </div>
                            
                            {
                               this.state.modalList.map(item =>{
                                return (<div style={{margin:"10px auto"}}>
                                    <Row type="flex" gutter={8} style={{marginLeft:"-8px!important"}}>
                                        <Col span={6}>
                                            <Col><span style={{ margin: "16px 0" }}>{item}:</span></Col>
                                        </Col> 
                                        <Col span={10}  style={{marginLeft:"10px"}}>
                                            <Input placeholder={`请输入${item}`} onChange={(e) => this.hadelTextChange(e,item)} value={item=="志愿者姓名"?this.state.zyzxm:(item=="志愿者联系电话"?this.state.zyzdh:(item=="志愿者微信"?this.state.zyzwx:(item=="学生姓名"?this.state.xsxm:(item=="学生身份证号"?this.state.xssfzh:""))))}/>
                                        </Col>
                                    </Row>
                                </div>);
                               }) 
                            }

                        </div>
                    </NHModal>
                    <NHExcel
                        ref="nhExcelBase"
                        title={'导入志愿者信息数据'}
                        templateName={'志愿者信息导入模板.xlsx'}
                        templateSign={'志愿者信息导入模板.xlsx'}
                        exportUrl={"/volunteer/zyzxx/import"}
                        onCancel={this.onExcelClose}
                    />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/zyzxx/index.js